import request from '@a/js/request'

// 查询版权信息
export function GetVersionOption(query) {
  return request({
    url: '/g/v1/version',
    method: 'get',
    params: query,
  })
}

// 获取单个项目信息
export function GetProjectInfo(query) {
  return request({
    url: '/b/base/v1/project',
    method: 'get',
    params: query,
  })
}

// 获取表单配置
// 弃用
export function GetFielOptions(query) {
  return request({
    url: '/c/form/v1/field',
    method: 'get',
    params: query,
  })
}

// 获取整体配置信息
// 弃用
export function GetFormOptions(query) {
  return request({
    url: '/c/form/v1/config',
    method: 'get',
    params: query,
  })
}

// 获取项目信息
export function GetProjectOptions(query) {
  return request({
    url: '/c/form/v1/form',
    method: 'get',
    params: query,
  })
}

// 修改项目
export function ModifyProject(params) {
  return request({
    url: '/b/base/v1/project',
    method: 'put',
    data: params,
  })
}

// 新增项目
export function AddProject(params) {
  return request({
    url: '/b/base/v1/project',
    method: 'post',
    data: params,
  })
}

// 获取用户信息
export function GetUserInfo(query) {
  return request({
    url: '/b/base/v1/user',
    method: 'get',
    params: query,
  })
}

/**
 * 图片上传前校验
 * @param file 待上传的文件对象
 */

export function BeforeImgUpload(file) {
  const isJPG = file.type === 'image/jpeg' || file.type === 'image/jpg'
  const isPNG = file.type === 'image/png'

  if (!(isJPG || isPNG)) {
    this.$notify({
      type: 'error',
      message: '只支持上传.jpg，.jpeg，.png格式的图片!',
    })
  }
  const isLt2M = file.size / 1024 / 1024 < 5
  if (!isLt2M) {
    this.$notify({
      type: 'error',
      message: '文件大小不能超过 5MB!',
    })
  }
  return (isJPG || isPNG) && isLt2M
}

/**
 * 文件上传前校验
 * @param file 待上传的文件对象
 */

export function BeforeFileUpload(file) {
  const isLt2M = file.size / 1024 / 1024 < 10
  if (!isLt2M) {
    this.$message.error('文件大小不能超过 5MB!')
  }
  return isLt2M
}

// 文件上传
export function Upload(params) {
  return request({
    url: '/g/v1/upload',
    method: 'post',
    data: params,
  })
}

// 文件上传鉴权
export function UploadAuthentication(params) {
  return request({
    url: '/g/v1/upload/upyun',
    method: 'post',
    data: params,
  })
}

// 查询区域编码
export function GetAreaCode(query) {
  return request({
    url: '/g/v1/pca/code',
    method: 'get',
    params: query,
  })
}

// 获取微信分享配置信息
export function GetWxshareConfig(params) {
  return request({
    url: '/g/v1/wx_share_info',
    method: 'post',
    data: params,
  })
}

// 发送验证码
export function ResForSendVerifyCode(params) {
  return request({
    url: '/g/v1/message/verify_code/sms',
    method: 'post',
    data: params,
  })
}

// 验证码校验
export function ResForCheckVerifyCode(params) {
  return request({
    url: '/g/v1/message/verify_code/verify',
    method: 'post',
    data: params,
  })
}
